var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import theme from '../../theme';
var MenuList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background-color: ", ";\n  border: 2px solid ", ";\n  border-radius: 4px;\n  overflow: auto;\n"], ["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background-color: ", ";\n  border: 2px solid ", ";\n  border-radius: 4px;\n  overflow: auto;\n"])), theme.primaryColours.white.main, theme.primaryColours.paleGray.main);
export default MenuList;
var templateObject_1;
